import { InMemoryHeader, InMemoryString, InMemoryDecimal } from "pbas-vue-components";

const PendingHourReportsTotalsHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.employer",
    type: new InMemoryString("Employer"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.TermName",
    type: new InMemoryString("Term"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.Amount",
    type: new InMemoryDecimal("TotalHours"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.pendinghourreports.ContributionAmount",
    type: new InMemoryDecimal("TotalContributionAmount"),
    sortable: true,
    visible: true,
    searchable: true
  }),
];
export default PendingHourReportsTotalsHeaders;
